import React from 'react';
import { Badge, Card, Col, Container, Row } from 'react-bootstrap';
import {
  FiAlertTriangle,
  FiCalendar,
  FiFileText,
  FiLock, FiSettings,
  FiUsers
} from 'react-icons/fi';
import '../Styles/MainStyles/Features.css';

const Features = () => {
  return (
    <section id="features" className="py-5 bg-light">
      <Container>
        <div className="text-center mb-5">
          <h2 className="fw-bold text-primary">Key Features</h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
            Comprehensive tools designed to simplify your audit processes
          </p>
        </div>
        
        <Row className="g-4">
          {features.map((feature, index) => (
            <Col lg={4} md={6} key={index}>
              <Card className="h-100 border-0 shadow-sm feature-card">
                <Card.Body className="p-4 text-center">
                  <div className="feature-header mb-3">
                    <div className={`icon-container ${feature.colorClass} mx-auto mb-3`}>
                      {feature.icon}
                    </div>
                    <h4 className="fw-bold">{feature.title}</h4>
                  </div>
                  <Card.Text className="text-muted">{feature.description}</Card.Text>
                  <div className="mt-3">
                    {feature.tags.map((tag, idx) => (
                      <Badge 
                        key={idx}
                        className={`me-2 mb-2 ${feature.badgeClass}`}
                        pill
                      >
                        {tag}
                      </Badge>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

const features = [
  {
    title: 'Audit Planning',
    description: 'Plan and schedule audits efficiently with our intuitive calendar and resource allocation tools.',
    icon: <FiCalendar size={24} />,
    tags: ['Scheduling', 'Resource Allocation', 'Calendar'],
     colorClass: 'bg-warning-light text-warning',
    badgeClass: 'bg-warning-light text-warning'
  },
  {
    title: 'Risk Assessment',
    description: 'Identify, evaluate and mitigate potential risks with our comprehensive assessment tools.',
    icon: <FiAlertTriangle size={24} />,
    tags: ['Risk Matrix', 'Control Evaluation', 'Mitigation'],
     colorClass: 'bg-warning-light text-warning',
    badgeClass: 'bg-warning-light text-warning'
  },
  {
    title: 'Document Management',
    description: 'Centralized storage for all audit documentation with version control and access management.',
    icon: <FiFileText size={24} />,
    tags: ['Version Control', 'Secure Storage', 'Access Logs'],
    colorClass: 'bg-warning-light text-warning',
    badgeClass: 'bg-warning-light text-warning'
  },
  {
    title: 'Team Collaboration',
    description: 'Real-time collaboration features for your audit teams with comments and task assignments.',
    icon: <FiUsers size={24} />,
    tags: ['Comments', 'Assignments', 'Notifications'],
     colorClass: 'bg-warning-light text-warning',
    badgeClass: 'bg-warning-light text-warning'
  },
  {
    title: 'Security & Compliance',
    description: 'Enterprise-grade security with role-based access control and compliance certifications.',
    icon: <FiLock size={24} />,
    tags: ['RBAC', 'Encryption', 'SOC 2'],
     colorClass: 'bg-warning-light text-warning',
    badgeClass: 'bg-warning-light text-warning'
  },
  {
    title: 'Customizable Workflows',
    description: 'Tailor the system to your organization\'s specific audit processes and requirements.',
    icon: <FiSettings size={24} />,
    tags: ['Drag & Drop', 'Approval Chains', 'Automation'],
     colorClass: 'bg-warning-light text-warning',
    badgeClass: 'bg-warning-light text-warning'
  }
];

export default Features;